import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App, { preloadRoute } from './App';
import { initAnalytics, rememberInternalBrowser, watchClicksAndErrors } from './analytics';

rememberInternalBrowser(); // ?internal=1 marks the owner's browser; see analytics.js
watchClicksAndErrors(); // coffee and X follow clicks, and errors visitors hit

// A pre-rendered page (scripts/prerender.js) ships its head tags for crawlers
// that don't run JavaScript. The app renders them again, so drop the static
// copies first; otherwise every page would carry two canonicals and titles.
document.querySelectorAll('[data-prerendered]').forEach((el) => el.remove());

// Analytics loads once the page has, so its 170 KB never competes with the
// page itself; page views queued before then are sent when it arrives.
if (document.readyState === 'complete') setTimeout(initAnalytics, 0);
else window.addEventListener('load', () => setTimeout(initAnalytics, 0), { once: true });

// Fetch a page's code as soon as someone shows intent to open it.
const preloadLink = (e) => {
  const a = e.target.closest?.('a[href^="/"]');
  if (a) preloadRoute(new URL(a.href).pathname).catch(() => {});
};
for (const type of ['mouseover', 'focusin', 'touchstart']) {
  document.addEventListener(type, preloadLink, { passive: true });
}

// Render once this page's own chunk is here, so the pre-rendered HTML is
// replaced by the same page rather than a loading state.
const render = () =>
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
preloadRoute(window.location.pathname).then(render, render);
